import type React from 'react';
import { useInstanceText } from '../hooks/portal/useInstanceMarkers';

type InstanceMarkerTextProps = {
  text: string;
};

/** The sibling of `InstanceBadge`, for a marker mentioned mid-sentence rather than alone. */
export const InstanceMarkerText: React.FC<InstanceMarkerTextProps> = ({ text }) => {
  const resolved = useInstanceText(text);
  return <>{resolved}</>;
};
